import CityPageTemplate from "../city-template/CityPageTemplate";
import { biddefordConfig } from "./data";

export default function BiddefordPage() {
  return <CityPageTemplate config={biddefordConfig} />;
}